module.exports = __webpack_public_path__ + "img/order-return.8c76bc89.svg";